import {createContext} from "react";


export const SearchBarContext = createContext(null)